import styled from 'styled-components';
import { isMobileBreakpoint } from 'ToolboxUtils/web/is-mobile-view';

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 40px;

  .title {
    font-family: ${props => props.theme.font.secondaryFont.name};
    // font-size: ${props => `${20*props.theme.font.secondaryFont.scaling/100}px`};
    font-size: 25px;
    font-weight: ${props => parseInt(props.theme.font.secondaryFont.weight)+300};
    // text-transform: uppercase;
    align-self: flex-start;
    margin-left: 20px;
  }

  .prices {
    align-self: flex-start;
    list-style: none;
    padding-left: 0;
    width: 100%;
    margin-top: 20px;
    font-size: ${props => `${17*props.theme.font.primaryFont.scaling/100}px`};
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 10px;
  }

  .price-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .name {
    font-weight: ${props => parseInt(props.theme.font.primaryFont.weight)+300};
  }

  .precision {
    font-size: ${props => `${16*props.theme.font.primaryFont.scaling/100}px`};
    grid-column-end: span 2;
  }

  @media (min-width: ${isMobileBreakpoint}px) {
    .prices {
      width: 50%;
    }
  }
`;

export default PriceWrapper;
